var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWebcamFeatures),expression:"showWebcamFeatures"}]},[_c('button',{on:{"click":_vm.getProduct}},[_vm._v("Found Product")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e1ce3f4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./EcomCore/Components/InputDevices/TestBarcodeReader.vue
// module id = 69
// module chunks = 0